import type { TreeMapFilterAssetConditionRatingItem } from "./tree-map-filter-asset-condition-rating.type";
import type { ReferentialConditionRatingValue } from "@/entities/referential/referential-condition-ratings";

import { getAssetTreeNodeAssetConditionRating } from "@/entities/asset-tree";
import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";

import { useTreeMap } from "../tree-map.context";
import { useTreeMapAssetsByValue } from "../tree-map.hook";

export const useTreeMapFilterAssetConditionRating = () => {
  const { conditionRatings } = useReferentialConditionRatings();

  const { getAssetsCount, getActiveAssetsCount } = useTreeMapAssetsByValue({
    getTreeNodeValue: getAssetTreeNodeAssetConditionRating,
  });

  const { subFilters, toggleSubFilter, setFilterByType } = useTreeMap();

  const filterItems = conditionRatings.map(
    ({ rating, name, color }): TreeMapFilterAssetConditionRatingItem => ({
      rating,
      name,
      color,
      count: getActiveAssetsCount(rating),
      checked: subFilters.conditionRating?.includes(rating),
      disabled: getAssetsCount(rating) === 0,
    })
  );

  const onToggle = (
    rating: ReferentialConditionRatingValue,
    isChecked: boolean
  ) => {
    toggleSubFilter({ type: "conditionRating", key: rating });

    // Activate parent filter if needed
    if (!isChecked) setFilterByType("asset", true);
  };

  return {
    filterItems,
    onToggle,
  };
};
